import { types } from 'mobx-state-tree';

import { Contact as BaseOccupant } from '../definitions/Common';
import {
    JobStatusValues,
    YearsWithActiveInsuranceValues,
    ContactTimes,
    DamageClaim,
    CancelRefusalClaim,
} from '../definitions/InsCommon';


export default BaseOccupant.named('OccupantModel')
    .props({
        policyStartDate: types.maybeNull(types.string),

        currentlyInsured: types.maybeNull(types.boolean),
        everInsured: types.maybeNull(types.boolean),
        hasClaims: types.maybeNull(types.boolean),

        jobStatus: types.maybeNull(types.enumeration(Object.values(JobStatusValues))),
        yearsWithActiveInsurance: types.maybeNull(types.enumeration(Object.values(YearsWithActiveInsuranceValues))),
        contactTime: types.optional(types.enumeration(Object.values(ContactTimes)), ContactTimes.ANYTIME),

        damageClaims: types.array(DamageClaim),
        cancelRefusalClaims: types.array(CancelRefusalClaim),
    })
    .views(self => ({
        get isComplete() {
            return (
                self.email !== null
                && self.phone !== null
                && self.firstName !== null
                && self.lastName !== null
                && self.dob !== null
                && self.policyStartDate !== null
                && self.jobStatus !== null
                && self.currentlyInsured !== null
            );
        },
    }));
